// src/storage/quota.js — localStorage quota self-healing (v129.99).
//
// Dar Al Salam, 9 Aug: "could not save .. storage full" on the opening
// checklist, plus 37 unhandled QuotaExceededErrors on the login write
// (`elcShiftUser` — a ~100-byte object). The till's 5MB origin quota was
// FULL, mostly with things that are only caches of DB truth:
//   - `elcAv:*` — the v126.7 profile-photo cache (one base64 JPEG per person;
//     a busy till can hold the whole company ≈ several MB), and
//   - `elc_cl_*` — checklist submission records, one per store/date/type
//     since go-live, never pruned (the DB has every one of them).
//
// lsSetSafe: setItem with an eviction ladder — on quota failure evict the
// avatar cache (it refetches lazily), then checklist records older than 90
// days, retrying after each rung. Small pure module; esbuild inlines it into
// each consuming bundle (no shared state — localStorage itself is shared).
//
// IMPORTANT product rule that rides with this: a full localStorage must
// NEVER block a DB write. The caches exist for fast reads; Supabase is the
// record. Callers treat lsSetSafe(...) === false as "carry on without the
// local copy", never as "abort".

export function evictAvatarCache() {
  var removed = 0;
  try {
    var kill = [];
    for (var i = 0; i < localStorage.length; i++) {
      var k = localStorage.key(i);
      if (k && k.indexOf('elcAv:') === 0) kill.push(k);
    }
    kill.forEach(function (k) { localStorage.removeItem(k); removed++; });
  } catch (e) { /* storage unavailable — nothing to evict */ }
  return removed;
}

// Checklist records older than keepDays (default 90). The date rides in the
// key: elc_cl_<Store_Name>_<YYYY-MM-DD>_<type>. String compare works on ISO.
export function evictOldChecklists(keepDays) {
  var removed = 0;
  try {
    var cutoff = new Date(Date.now() - (keepDays || 90) * 86400000).toISOString().slice(0, 10);
    var kill = [];
    for (var i = 0; i < localStorage.length; i++) {
      var k = localStorage.key(i);
      if (!k || k.indexOf('elc_cl_') !== 0) continue;
      var m = k.match(/_(\d{4}-\d{2}-\d{2})_/);
      if (m && m[1] < cutoff) kill.push(k);
    }
    kill.forEach(function (k) { localStorage.removeItem(k); removed++; });
  } catch (e) { /* storage unavailable */ }
  return removed;
}

export function lsSetSafe(key, value) {
  try { localStorage.setItem(key, value); return true; } catch (e0) { /* quota — start evicting */ }
  evictAvatarCache();
  try { localStorage.setItem(key, value); return true; } catch (e1) { /* still full */ }
  evictOldChecklists(90);
  try { localStorage.setItem(key, value); return true; } catch (e2) { /* give up — caller carries on */ }
  return false;
}
